const colors = {
  // FIFA colors
  green: '#00d400',
  yellow: '#ffcc00',
  lightBlue: '#4994ce',
  lightGreen: '#86b519',
  purple: '#8a1a67',
  orange: '#f09316',
  darkOrange: '#ec6812',
  darkGreen: '#00693c',
  darkBlue: '#326295',

  // Global colors
  light: '#ffffff',
  grey: '#b5b9bb',
  dark: '#4d4f53',
  black: '#000000',

  // Metallic colors
  gold: '#383421',
  silver: '#43464a',
  bronze: '#4f3423',

  // System colors
  error: '#ff0000',
  accept: '#18ff66',
};

const breakpoints = {
  small: 768,
  medium: 1024,
  large: 1280,
  max: 1920,
};

const opacities = {
  overlay: 0.8,
  tableLines: 0.2,
  tableHover: 0.2,
  pieChartMax: 0.25,
  barChartStep: 0.15,
};

const transitionTimingFunctions = {
  easeInOut: 'cubic-bezier(.86,0,.07,1)',
};

const fontFamily = '"Open Sans", sans-serif';

// Values in pixel, automatically calculates to rem
const fontSizes = {
  base: 16,
  xxl: {
    fs: 45,
    lh: 45,
    small: {
      fs: 100,
      lh: 100,
    },
    medium: {
      fs: 100,
      lh: 100,
    },
  },
  xl: {
    fs: 38,
    lh: 38,
    small: {
      fs: 48,
      lh: 48,
    },
    medium: {
      fs: 48,
      lh: 48,
    },
  },
  xll: {
    fs: 22,
    lh: 36,
    small: {
      fs: 40,
      lh: 52,
    },
    medium: {
      fs: 40,
      lh: 52,
    },
  },
  l: {
    fs: 22,
    lh: 32,
    small: {
      fs: 40,
      lh: 52,
    },
    medium: {
      fs: 40,
      lh: 52,
    },
  },
  m: {
    fs: 18,
    lh: 20,
    small: {
      fs: 25,
      lh: 30,
    },
    medium: {
      fs: 25,
      lh: 30,
    },
  },
  s: {
    fs: 16,
    lh: 25,
  },
  paragraph: {
    fs: 18,
    lh: 32,
    small: {
      fs: 20,
      lh: 20,
    },
    medium: {
      fs: 20,
      lh: 20,
    },
  },

  menu: {
    fs: 20,
    lh: 30,
  },

  caption: {
    fs: 13,
    lh: 18,
  },
  footer: {
    fs: 16,
    lh: 32,
  },
  logo: {
    fs: 18,
    lh: 20,
  },
  errorCode: {
    fs: 70,
    lh: 80,
    medium: {
      fs: 140,
      lh: 150,
    },
  },
};

const theme = {
  colors,
  font: {
    family: fontFamily,
    sizes: fontSizes,
  },
  breakpoints: {
    above: {
      small: `(min-width: ${breakpoints.small}px)`,
      medium: `(min-width: ${breakpoints.medium}px)`,
      large: `(min-width: ${breakpoints.large}px)`,
      max: `(min-width: ${breakpoints.max}px)`,
    },
    below: {
      small: `(max-width: ${breakpoints.small - 1}px)`,
      medium: `(max-width: ${breakpoints.medium - 1}px)`,
      large: `(max-width: ${breakpoints.large - 1}px)`,
      max: `(max-width: ${breakpoints.max - 1}px)`,
    },
  },
  opacities,
  transitionTimingFunctions,
};

export const toRgba = (hexColor: string, opacity: number): string => (
  `rgba(${
    parseInt(hexColor.substring(1, 3), 16)}, ${
    parseInt(hexColor.substring(3, 5), 16)}, ${
    parseInt(hexColor.substring(5, 7), 16)}, ${
    opacity})`
);

export default theme;
